import { Box, styled, Theme } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      maxWidth: "85%",
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    modalHeading: {
      fontWeight: 700,
      fontSize: "22px",
      color: colors.gray600,
      marginBottom: "10px",
    },
    header: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  })
);

export const Content = styled(Box)(() => ({
  width: "100%",
  fontFamily: "Manrope !important",
  flex: 1,
  flexDirection: "column",
  paddingBottom: "15px",
  alignItems: "center",
  justifyContent: "center",
}));

export default useStyles;
